// extracted by mini-css-extract-plugin
module.exports = {"social":"_c8de408b","socialButton":"_ff40865d","contact":"_cf44a690","shareButton":"_dc6f4acb","socialShareWrapper":"_f2e13755"};